<div class="pv2-seletor">
  <div class="pv2-seletor__estado" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando produtos...</p>
  </div>

  <div class="pv2-seletor__estado is-erro" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <div>
      <strong>Não foi possível carregar os produtos</strong>
      <p>{{ errorMessage }}</p>
      <button type="button" class="pv2-seletor__link" (click)="load()">Tentar de novo</button>
    </div>
  </div>

  <ng-container *ngIf="!loading && !errorMessage">
    <p class="pv2-seletor__vazio" *ngIf="!products.length">
      Cadastre produtos antes de vincular adicionais.
    </p>

    <p class="pv2-seletor__vazio" *ngIf="products.length && tudoVinculado">
      Este adicional já está em todos os produtos do catálogo.
    </p>

    <ng-container *ngIf="products.length && !tudoVinculado">
      <div class="pv2-seletor__toolbar">
        <label class="pv2-seletor__busca">
          <span class="fa fa-search"></span>
          <input [(ngModel)]="search" type="search" placeholder="Buscar produto ou categoria">
        </label>
        <button type="button" class="pv2-seletor__link" *ngIf="selectedCount" (click)="clearSelection()">
          Limpar seleção
        </button>
      </div>

      <p class="pv2-seletor__vazio" *ngIf="!categories.length">Nenhum produto encontrado.</p>

      <div class="pv2-seletor__categorias">
        <fieldset class="pv2-seletor-categoria" *ngFor="let group of categories; trackBy: trackByCategory">
          <legend>
            <label class="pv2-seletor-categoria__todos">
              <input type="checkbox"
                     [checked]="isCategoryFullySelected(group)"
                     [indeterminate]="categorySelectedCount(group) > 0 && !isCategoryFullySelected(group)"
                     [disabled]="!podeEditar || !categoriaDisponivel(group).length"
                     (change)="toggleCategory(group)">
              <strong>{{ group.name }}</strong>
              <small>{{ categorySelectedCount(group) }}/{{ categoriaDisponivel(group).length }}</small>
            </label>
          </legend>

          <label class="pv2-seletor-produto"
                 *ngFor="let product of group.products; trackBy: trackByProduct"
                 [class.is-selected]="isSelected(product) && !estaVinculado(product)"
                 [class.is-travado]="estaVinculado(product)">
            <input type="checkbox"
                   [checked]="isSelected(product)"
                   [disabled]="estaVinculado(product) || !podeEditar"
                   (change)="toggleProduct(product)">
            <span class="pv2-seletor-produto__avatar">{{ product.emoji || '🍽️' }}</span>
            <span class="pv2-seletor-produto__nome">{{ product.name }}</span>
            <span class="pv2-seletor-produto__marca" *ngIf="estaVinculado(product)">já tem</span>
          </label>
        </fieldset>
      </div>

      <footer class="pv2-seletor__rodape">
        <div class="pv2-seletor__contagem">
          <span *ngIf="totalVinculados">{{ totalVinculados }} já vinculados</span>
          <span class="is-forte">{{ selectedCount }} selecionados</span>
        </div>
        <div class="pv2-seletor__acoes">
          <button type="button" class="pv2-ghost-btn" (click)="cancelou.emit()">Cancelar</button>
          <button type="button" class="pv2-primary-btn"
                  [disabled]="!selectedCount || ocupado || !podeEditar"
                  (click)="confirmar()">
            <span class="fa fa-spinner fa-spin" *ngIf="ocupado"></span>
            {{ rotuloDoBotao }}
          </button>
        </div>
      </footer>
    </ng-container>
  </ng-container>
</div>
